import { apiGet } from "../../api/client";

export interface LiveResponse {
  ok: boolean;
  service: string;
  version: string;
}

export interface Market {
  code: string;
  name: string;
  icon_url: string | null;
  sell_only: boolean;
}

export interface MarketsResponse {
  ok: boolean;
  rows: Market[];
}

export function getLiveness(signal?: AbortSignal): Promise<LiveResponse> {
  return apiGet<LiveResponse>("/api/v1/health/live", signal);
}

export function getMarkets(signal?: AbortSignal): Promise<MarketsResponse> {
  return apiGet<MarketsResponse>("/api/v1/markets", signal);
}

